import {useEffect, useState} from 'react';
import { get } from "lodash";

import useCart from "grandus-lib/hooks/useCart";
import { Select, Radio, message } from "antd";
import EnhancedEcommerce from "utils/ecommerce";
import TagManager from "grandus-lib/utils/gtag";
import FBPixel from "grandus-lib/utils/fbpixel";
import { useRouter } from "next/router";
import { LoadingOutlined } from "@ant-design/icons";
import {LeadhubSetCart} from 'utils/leadhub';
const { Option } = Select;

import styles from "./AddToCartButton.module.scss";
import FBCAPI from "grandus-lib/utils/fbcapi";
import Remarketing from "grandus-lib/utils/remarketing";
import SalesManago from "utils/salesmanago";

const PartSize = ({ stores, productId, selectedValue, handleChange }) => {
  if (stores.length <= 4) {
    return (
      <Radio.Group
        onChange={(e) => handleChange(e.target.value)}
        value={selectedValue}
      >
        {stores.map((store, index) => (
          <Radio
            key={`product-${productId}-store-${get(
              store,
              "id"
            )}-option-${index}`}
            value={get(store, "id")}
          >
            {get(store, "name")}
          </Radio>
        ))}
      </Radio.Group>
    );
  } else {
    return (
      <Select
        placeholder={"Vyberte možnosť"}
        onChange={(value) => handleChange(value)}
        value={selectedValue}
      >
        {stores.map((store, index) => (
          <Option
            key={`product-${productId}-store-${get(
              store,
              "id"
            )}-option-${index}`}
            value={get(store, "id")}
          >
            {get(store, "name")}
          </Option>
        ))}
      </Select>
    );
  }
};

const AddToCartButton = ({ productId, stores, options = {} }) => {
  if (!stores.length) return null;

  const router = useRouter();
  const { cart, itemAdd } = useCart();

  const [count, setCount] = useState(1);
  const [store, setStore] = useState(get(stores, "[0].id"));
  const [loading, setLoading] = useState(false);

    useEffect(() => {
        LeadhubSetCart(cart?.items);
    },[cart?.items])

  const key = `message-add-to-cart-${productId}`;

  async function handleAddToCart(e) {
    setLoading(true);
    message.loading({
      content: "Vkladám položku do nákupného košíka",
      duration: 0,
      key,
    });
    const requestOptions = {};
    if (router?.query?.hash) {
      requestOptions.hash = get(router, "query.hash");
    }
    itemAdd(
      count,
      store,
      productId,
      (cart) => {
        message.success({
          content: "Položka bola úspešne pridaná do nákupného košíka",
          duration: 1,
          key,
        });
        TagManager.push(
          EnhancedEcommerce.cartAdd(get(options, "eecProduct"), count)
        );
        TagManager.push(Remarketing.addToCart(get(options, "eecProduct")));
        FBPixel.track(
          "AddToCart",
          FBPixel.productDetail(get(options, "eecProduct"), { quantity: count })
        );
        FBCAPI.send(
          "AddToCart",
          FBCAPI.productDetail(get(options, "eecProduct"), { quantity: count })
        );
        SalesManago.checkout(cart, "add");
        setLoading(false);
      },
      requestOptions
    );
    return false;
  }

  return (
    <div
      className={[styles.addCartBox, styles[get(options, "class", "")]].join(
        " "
      )}
    >
      {/* <PartSize
          stores={stores}
          productId={productId}
          selectedValue={store}
          handleChange={(value) => setStore(value)}
        /> */}

      <div className={styles.quantity}>
        <a
          className="plus spin-button"
          onClick={(e) => {
            setCount(count + 1);
          }}
        >
          <img
            src="https://instance5.admin.grandus.sk/files/attachment/2020-11/6460/23705f/icon-plus.svg"
            style={{ width: "13px" }}
            alt=""
          />
        </a>
        <input
          type="number"
          value={count}
          min="0"
          max="99"
          onChange={(e) => setCount(e.target.value)}
        />
        <a
          className="minus spin-button"
          onClick={(e) => {
            if (count < 2) {
              setCount(1);
              return;
            }
            setCount(count - 1);
          }}
        >
          <img
            src="https://instance5.admin.grandus.sk/files/attachment/2020-11/6553/e0c460/minus.svg"
            style={{ width: "13px" }}
            alt=""
          />
        </a>
      </div>

      <div className={styles.addCart}>
        <a onClick={handleAddToCart} className="button primary">
          Vložiť do košíka
          {loading ? (
            <LoadingOutlined />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="20"
              viewBox="0 0 28.982 26.301"
            >
              <g transform="translate(0 0)">
                <path
                  d="M303.809,197.223H286.443l-2.092-14.265-5.514-4.088,1.43-1.928,6.315,4.682,1.936,13.2h13.452l2.721-10.132H290.437v-2.4h17.382Z"
                  transform="translate(-278.836 -176.941)"
                />
                <circle
                  cx="2.531"
                  cy="2.531"
                  r="2.531"
                  transform="translate(8.432 21.239)"
                />
                <circle
                  cx="2.531"
                  cy="2.531"
                  r="2.531"
                  transform="translate(19.467 21.239)"
                />
              </g>
            </svg>
          )}
        </a>
      </div>
    </div>
  );
};

export default AddToCartButton;
